
    export const PageTitleStyles = {
        fontSize: "20px"
    }
    export const CreateNewButtonStyles = {
        marginTop: "22px"
    }
    export const SearchBarStyles = {
        marginTop: "15px"
    }
    export const FormTitleStyles = {
        fontWeight: "800",
        fontSize: "15px"
    }
    export const FormFieldsStyles = {
        padding: "30px"
    }
    export const SaveButtonStyles = {
        border: "3px solid",
        marginTop: "50px",
        marginRight: "5px",
        fontWeight: "900",
        fontSize: "16px",
        borderRadius: "12px"
    }
    export const DocumentListItemStyles = {
        marginBottom: "20px",
        height: "75px"
    }
    export const DocumentUpdateListStyles = {
        marginTop: "50px",
        maxWidth: "740px"
    }
    export const NoDocumentStyles = {
        fontWeight: "bold"
    }
    export const PaperItemStyles = {
        height: "75px"
    }
    export const CalendarCellStyles = {
        marginRight: "30px",
        width: "80%"
    }
    export const PaperFirmNameStyles = {
        fontWeight: "bold"
    }
    export const DocumentTextGridStyles = {
        marginTop: "7px"
    }
    export const DetailButtonStyles = {
        //marginBottom: "auto",
        width: "90%"
    }
    export const DetailButtonGridStyles = {
        marginTop: "20px"
    }
    export const DocumentItemStyles = {
        marginBottom: "20px",
        height: "75px"
    }
    export const DocumentDetailsTextfieldStyles = {
        marginLeft: "10px",
        marginTop: "20px"
        //width: "260px"
    }
    export const DetailsTitleStyles = {
        fontWeight: "bold"
    }
    export const DocumentDetailsTextfieldOwnerStyles = {
        marginLeft: "30px",
        marginTop: "40px"
    }
    export const ConfirmationGridStyles = {
        marginTop: "50px"
    }
    export const SwapSortIconStyles = {
    
    }
    export const BackButtonMainStyles = {
        marginRight: "auto",
        marginLeft: "7vw"
    }
    export const ISOPageTitleStyles = {
        marginRight: 'auto',
        marginLeft: "-12vw",
        fontSize: "18px",
        marginTop: "10px"
    }
